// Onay akışı statü/talep türü sabitleri — bkz. docs/talep_olustur_onay_akısı.md.
//
// Yalnızca "Tüm Talepler" sekmesi (AllRequestsTab / AllRequestsTable / AllRequestsForm /
// StatusChangeDialog / RequestCommentHistoryDialog) tarafından kullanılır; mevcut "Yayınlanan
// Eğitimler" / "Talep Edilen Eğitimler" sekmelerini (PublishedTrainingsTab.jsx /
// RequestedTrainingsTab.jsx ve formları) hiçbir şekilde etkilemez.

export const REQUEST_STATUS = {
    DRAFT: 10,
    RETURNED: 15,
    PENDING_APPROVAL: 20,
    ACCEPTED: 30,
    REJECTED: 40
};

// Tag/badge renk şiddeti — PrimeReact Tag `severity` değerleri.
export const REQUEST_STATUS_SEVERITY = {
    [REQUEST_STATUS.DRAFT]: 'secondary',
    [REQUEST_STATUS.RETURNED]: 'warning',
    [REQUEST_STATUS.PENDING_APPROVAL]: 'info',
    [REQUEST_STATUS.ACCEPTED]: 'success',
    [REQUEST_STATUS.REJECTED]: 'danger'
};

// i18n `trainingRequest.allRequests.statuses.<key>` alt anahtarları.
export const REQUEST_STATUS_I18N_KEY = {
    [REQUEST_STATUS.DRAFT]: 'draft',
    [REQUEST_STATUS.RETURNED]: 'returned',
    [REQUEST_STATUS.PENDING_APPROVAL]: 'pendingApproval',
    [REQUEST_STATUS.ACCEPTED]: 'accepted',
    [REQUEST_STATUS.REJECTED]: 'rejected'
};

// Statü filtresi dropdown'u için sıralı liste.
export const REQUEST_STATUS_OPTIONS = [REQUEST_STATUS.DRAFT, REQUEST_STATUS.RETURNED, REQUEST_STATUS.PENDING_APPROVAL, REQUEST_STATUS.ACCEPTED, REQUEST_STATUS.REJECTED];

// Doküman: "Red (40) ve İade (15) için yorum zorunlu, diğerlerinde opsiyonel."
export const COMMENT_REQUIRED_STATUSES = [REQUEST_STATUS.REJECTED, REQUEST_STATUS.RETURNED];

export const REQUEST_TYPE = {
    PUBLISHED: 1,
    REQUESTED: 2
};

export const REQUEST_TYPE_OPTIONS = [REQUEST_TYPE.PUBLISHED, REQUEST_TYPE.REQUESTED];

// Satır bazlı statü geçiş butonları — doküman: "allowedStatuses o kayıt için hangi geçişlerin
// mümkün olduğunu söylüyor — içinde 20 varsa 'Onaya Gönder', 30 varsa 'Kabul', 40 varsa 'Red',
// 15 varsa 'İade' butonu göster."
export const STATUS_ACTIONS = [
    { targetStatus: REQUEST_STATUS.PENDING_APPROVAL, icon: 'pi pi-send', colorClass: 'text-blue-500 hover:text-blue-700', i18nKey: 'sendForApproval' },
    { targetStatus: REQUEST_STATUS.ACCEPTED, icon: 'pi pi-check', colorClass: 'text-green-500 hover:text-green-700', i18nKey: 'accept' },
    { targetStatus: REQUEST_STATUS.REJECTED, icon: 'pi pi-times', colorClass: 'text-red-500 hover:text-red-700', i18nKey: 'reject' },
    { targetStatus: REQUEST_STATUS.RETURNED, icon: 'pi pi-replay', colorClass: 'text-orange-500 hover:text-orange-700', i18nKey: 'return' }
];
